export default "__VITE_ASSET__BF3M_LP3__"